import ApiAcces from "@/shared/services/ApiAcces";
import type IWorkflowAccessService from "../contracts/IWorkflowAccessService";
import type WorkflowAccess from "../models/WorkflowAccess";
import type { GrantWorkflowAccessRequest } from "../models/WorkflowAccess";

export default class WorkflowAccessService
  extends ApiAcces
  implements IWorkflowAccessService {
  async GetByWorkflow(workflowId: string): Promise<WorkflowAccess[]> {
    return (await this.api.get(`api/workflows/${workflowId}/access`)).data;
  }

  async Grant(workflowId: string, grantedToUserId: string): Promise<WorkflowAccess> {
    const request: GrantWorkflowAccessRequest = { GrantedToUserId: grantedToUserId };
    return (await this.api.post(`api/workflows/${workflowId}/access`, request)).data;
  }

  async Update(workflowId: string, accessId: string, enabled: boolean): Promise<void> {
    // El endpoint bindea [FromBody] bool: el payload tiene que ser un `true`/`false` pelado,
    // no un objeto { enabled }.
    await this.api.patch(
      `api/workflows/${workflowId}/access/${accessId}`,
      JSON.stringify(enabled),
      { headers: { "Content-Type": "application/json" } },
    );
  }

  async Revoke(workflowId: string, accessId: string): Promise<void> {
    await this.api.delete(`api/workflows/${workflowId}/access/${accessId}`);
  }
}
